// debounceFetchReleases.js
import { getReleases } from 'common/services/releases.service';
import debounce from 'debounce-promise';
import { shouldChangeV3BasedBranches } from '../../../activity.utils';

import { handleTimeFilterAsTimestamps } from 'common/utils/utils';
const defaultState = { items: [], total: 0 };

const debouncedFetchReleases = debounce(
  async ({
    params,
    withIncidentsCount,
    initialSearch,
    location,
    search,
    fetchReleaseIds,
    setReleases,
    toast,
    isAllContributorsTeam,
    isDrilldownMode
  }) => {
    try {
      const payload = {
        ...params,
        filter: {
          ...params?.filter,
          ...handleTimeFilterAsTimestamps(params?.filter, 'released_at')
        },
        ...(withIncidentsCount ? { bound_incidents_count: true } : {})
      };
      if (
        !shouldChangeV3BasedBranches(initialSearch, location.search) &&
        search.metric_name &&
        isDrilldownMode
      ) {
        const releaseIds = await fetchReleaseIds(search);
        const payloadWithV3Releases = {
          ...payload,
          filter: { release_ids: releaseIds }
        };
        if (releaseIds.length) {
          const releasesRes = await getReleases(payloadWithV3Releases);
          setReleases(releasesRes);
        } else {
          setReleases(defaultState);
        }
      } else {
        const releasesRes = await getReleases(payload);
        setReleases(releasesRes);
      }
    } catch (e) {
      setReleases(defaultState);
      toast({
        variant: 'error',
        message: 'Ooops... Something went wrong'
      });
    }
  },
  1000
);

export default debouncedFetchReleases;
